module.exports = __webpack_public_path__ + "12be067a6270759b4f861d64cc267166.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/clarity-ui/dist/fonts/open-sans-extrabold.ttf
// module id = 1532
// module chunks = 0